// Teléfonos: se GUARDAN solo los dígitos (para que la búsqueda por número
// siempre encuentre), pero se MUESTRAN con rayitas (787-555-1234).
// Pedido del cliente 2026-08-18: nada de () ni - en el récord.

export const phoneDigits = (v) => String(v || '').replace(/\D/g, '');

export const formatPhoneDisplay = (v) => {
  const d = phoneDigits(v);
  if (d.length === 10) return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
  if (d.length === 11 && d[0] === '1') return `1-${d.slice(1, 4)}-${d.slice(4, 7)}-${d.slice(7)}`;
  if (d.length === 7) return `${d.slice(0, 3)}-${d.slice(3)}`;
  return d;
};
